import Vue from 'vue'

import ICountUp from '@/node_modules/vue-countup-v2'

Vue.component('count', ICountUp)